import { HttpInterceptorFn } from '@angular/common/http';

export const cultureHeaderInterceptor: HttpInterceptorFn = (req, next) => {
  // ABP'nin backend'e Türkçe culture bilgisi göndermesini sağla
  const modifiedReq = req.clone({
    setHeaders: {
      'Accept-Language': 'tr-TR,tr;q=0.9',
      'Content-Language': 'tr-TR'
    }
  });
  
  return next(modifiedReq);
};